import React from 'react';
import {
    Preloader,
} from 'framework7-react';
import {StripeProvider, Elements} from 'react-stripe-elements';
import InjectedCheckoutForm from './CheckoutForm';

export default class StripeCheckout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {stripe: null, ready:false, loading_stripe:true};
    }

    render() {
        return (
            this.state.stripe ?
            <StripeProvider stripe={this.state.stripe}>
                <Elements locale="no">
                    <InjectedCheckoutForm group={this.props.group} sid={this.props.sid} price={this.props.price} ready={this.state.ready} reload={this.props.reload.bind(this)} theme={this.props.theme}/>
                </Elements>
            </StripeProvider>
            :
            <div className="text-align-center" style={{margin:'26px'}}>
                <Preloader></Preloader>
            </div>
        )
    }

    componentDidMount() {
        //load stripe
        this.loadStripeScript();
    }

    set_up_stripe = () => {
        //pk_live_6hoG2WRHh1JFFkjhryYQUk8C00bIbvsr4z
        if(this.props.stripe_key){
            if (window.Stripe) {
                    this.setState({stripe: window.Stripe('pk_live_6hoG2WRHh1JFFkjhryYQUk8C00bIbvsr4z', {stripeAccount: this.props.stripe_key}),ready:true});
            } else {
                    document.querySelector('#stripe-js').addEventListener('load', () => {
                    // Create Stripe instance once Stripe.js loads
                    this.setState({stripe: window.Stripe('pk_live_6hoG2WRHh1JFFkjhryYQUk8C00bIbvsr4z', {stripeAccount: this.props.stripe_key}),ready:true});
                    });
            }
        }
    }

    loadStripeScript() {
        const self = this;
        var aScript = document.createElement('script');
        aScript.setAttribute("id", "stripe-js");
        aScript.type = 'text/javascript';
        aScript.src = "https://js.stripe.com/v3/";
        document.head.appendChild(aScript);
        aScript.onload = function() {
            self.set_up_stripe();
        };
    }
}